<div class="admin-container" #container>
  <div *ngIf="loading" class="spinner">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-toast position="bottom-right"></p-toast>
  <p-confirmDialog [appendTo]="container"></p-confirmDialog>

  <p-tabs value="informations">
    <p-tablist>
      <p-tab value="informations">Informations</p-tab>
      <p-tab value="sections">Sections</p-tab>
      <p-tab value="seo">SEO</p-tab>
      <p-tab value="sticky-links">Sticky links</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="informations">
        <admin-article-info [(articleModel)]="articleModel"></admin-article-info>
      </p-tabpanel>
      <p-tabpanel value="sections">
        <admin-article-sections [(articleModel)]="articleModel"></admin-article-sections>
      </p-tabpanel>
      <p-tabpanel value="seo">
        <admin-article-seo [(articleModel)]="articleModel"></admin-article-seo>
      </p-tabpanel>
      <p-tabpanel value="sticky-links">
        <article-sticky-link [(articleModel)]="articleModel"></article-sticky-link
      ></p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
<div class="save">
  <button pButton label="Save" (click)="save()"></button>
  <a
    pButton
    class="preview"
    label="See preview"
    target="_blank"
    *ngIf="articleModel.slug"
    [routerLink]="'../' + articleModel.slug + '/preview'"
  ></a>
</div>
